module.exports = __webpack_public_path__ + "static/media/proj9_img2.a64ba78b.jpg";